<script lang="ts">
      import { getScrollContext, type ScrollTracker } from '$lib/ui/scroll/index.svelte'
      import { getContext, onDestroy, onMount } from 'svelte'
      import Globus from '../ui/Globus.svelte'
      import Menu from '../menu/Menu.svelte'
      import { getHeaderVisiblityContext } from '$lib/ui/menu/index.svelte'
      import { browser } from '$app/environment'
      import { getDebugContext } from '../context/ts/Debug.svelte'

      const scroll: ScrollTracker = getScrollContext()
      const ui = getHeaderVisiblityContext()
      const debug = getDebugContext()
      let bar: HTMLDivElement

      let barOpen = $state(false)

      function barState() {
            if (ui.menuRequested.size !== 0) return
            if (ui.globalMenuVisibility == true) return (ui.menuOpen = true)
            if (scroll.scrollY > 20) return (ui.menuOpen = true)
            return (ui.menuOpen = false)
      }

      async function handleMouseover(ev: Event) {
            const target = ev.currentTarget
            ui.requestMenuVisible(target)
      }

      async function handleMouseleave(ev: Event) {
            const target = ev.currentTarget
            ui.releaseMenuVisible(target)
      }

      onMount(() => {
            const ctrl = new AbortController()

            bar.addEventListener('mouseover', handleMouseover, { signal: ctrl.signal })
            bar.addEventListener('mouseleave', handleMouseleave, { signal: ctrl.signal })

            return ctrl.abort
      })

      $effect(() => {
            ui.menuRequestedChange
            barState()
      })
</script>

<div class="sticky top-0 left-0 w-full z-20">
      <div class="absolute w-full top-0 z-20 left-0 h-fit font-[300]">
            <div bind:this={bar} class="bar relative transition-all ease-in-out duration-700 w-full flex pt-2 pb-1 justify-left opacity-100 items-center {ui.menuOpen ? 'open' : 'closed'}">
                  <a href="/" class="h-full">
                        <Globus class="{ui.menuOpen ? 'opacity-100' : 'opacity-0'} h-full ml-2 transition-all ease-in-out duration-700 hover:opacity-50"></Globus>
                  </a>
                  <Menu></Menu>
            </div>
      </div>
</div>

<!--{#if ui.globalMenuVisibility}-->
      <div class="padding-bar bg-transparent {ui.globalMenuVisibility ? "h-[5rem]": "h-[0rem]"}"></div>
<!--{/if}-->

<style lang="postcss">
      .bar {
            @apply h-[3rem];
      }

      .bar:global(.open) {
            @apply bg-[#FFFFFFFF] shadow-lg;
      }

      .bar:global(.closed) {
            @apply bg-[#FFFFFF00];
      }

      .padding-bar {
            transition: all .3s ease-in-out;
      }
</style>
